export default "__VITE_ASSET__a8e8a8ea__"